import { KeyValuePipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { translateSignal } from '@jsverse/transloco';
import { BigUntypedFormGroup } from '../form-control/big-form-group';
import { FormService } from '../services/form/form.service';

@Component({
    selector: 'big-form-state-preview',
    templateUrl: './state-preview.component.html',
    imports: [KeyValuePipe, NgTemplateOutlet],
})
export class StatePreviewComponent {
    private readonly formService = inject(FormService);

    public readonly showFormState = signal(false);
    public readonly requiredTranslation = translateSignal('ftbStatePreview.required');

    public get control(): BigUntypedFormGroup {
        return this.formService.currentForm;
    }

    public isFormGroup(control: unknown): control is BigUntypedFormGroup {
        return control instanceof BigUntypedFormGroup;
    }
}
